// @flow
import * as React from 'react';
import {useState} from 'react';
import {ReactFlowProvider} from 'react-flow-renderer';
import Group from 'sail/Group';
import Box from 'sail/Box';

import {
  DiagramGeneratorProvider,
  SequenceDiagramProvider,
} from 'docs/data/diagram';
import {OnlyRenderOnClient} from 'docs/components';
import {DiagramGeneratorContent} from './DiagramGeneratorContent';
import {DiagramLoadingSkeleton} from '../Diagram';
import type {DiagramType} from '../types';
import './DiagramGenerator.scss';
import '../Diagram.scss';

type DiagramGeneratorProps = {|
  type: DiagramType,
|};

export const DiagramGenerator = ({type}: DiagramGeneratorProps) => {
  const [loading, setLoading] = useState(true);
  return (
    <Box className="DiagramGenerator">
      {loading && <DiagramLoadingSkeleton />}
      <OnlyRenderOnClient>
        <Group margin={{top: 16}}>
          <ReactFlowProvider>
            <SequenceDiagramProvider>
              <DiagramGeneratorProvider
                initialType={type}
                setLoading={setLoading}
              >
                <DiagramGeneratorContent />
              </DiagramGeneratorProvider>
            </SequenceDiagramProvider>
          </ReactFlowProvider>
        </Group>
      </OnlyRenderOnClient>
    </Box>
  );
};
